import auth from "@/services/auth";
import store from "@/store/index";
import cookies from "@/storage/cookies";
import { INVITE_COOKIE_NAME } from "@/constants";
import { createValidationError } from "@/utils/validation";
import flash from "@/services/flash";

export default async (to, from, next) => {
  const isInvite = to.matched.some(record => !!record.meta.invite);

  if (isInvite) {
    return next(false);
  }

  let code = await cookies.get(INVITE_COOKIE_NAME);
  if (!code) {
    return next();
  }

  if (!(await auth.isAuthenticated())) {
    return next();
  }

  try {
    await acceptInvite(code);
    await getCustomer();

    next();
  } catch (e) {
    const ve = createValidationError(e);
    ve.errors.forEach(error => flash.error(error.reason));
    next({ name: "invite", params: { code } });
    return false;
  }
};

async function acceptInvite(code) {
  try {
    return await store.dispatch("friendLists/acceptFriendListInvite", code);
  } finally {
    await cookies.remove(INVITE_COOKIE_NAME);
  }
}

function getCustomer() {
  return store.dispatch("customers/getCustomer");
}
